/* fooldal-v2 — Érezd a lelked új főoldal interakciói.
   A DC-mockup állapot-bindingjainak (need / message / openFaq / sent) vanilla JS megfelelője.
   FONTOS: a tartalom MINDIG a kiszolgált HTML-ben van (SEO) — a JS csak láthatóságot kapcsol.
   A GYIK natív <details>, a küldés natív Shopify contact form — azokhoz nem kell JS.
   Section-scope-olt, shopify:section:load-ra újrainicializál. */
(function () {
  'use strict';

  function initRoot(root) {
    if (!root || root.__fv2Init) return;
    root.__fv2Init = true;

    /* ── 01 Iránytű ── */
    var needBtns = root.querySelectorAll('[data-fv2-need]');
    var panels = root.querySelectorAll('[data-fv2-panel]');

    function showNeed(idx) {
      for (var i = 0; i < panels.length; i++) {
        panels[i].hidden = panels[i].getAttribute('data-fv2-panel') !== String(idx);
      }
      for (var j = 0; j < needBtns.length; j++) {
        var on = needBtns[j].getAttribute('data-fv2-need') === String(idx);
        needBtns[j].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }
    function clearNeed() {
      for (var i = 0; i < panels.length; i++) panels[i].hidden = true;
      for (var j = 0; j < needBtns.length; j++) needBtns[j].setAttribute('aria-pressed', 'false');
    }

    Array.prototype.forEach.call(needBtns, function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-fv2-need');
        var already = btn.getAttribute('aria-pressed') === 'true';
        if (already) { clearNeed(); } else { showNeed(idx); }
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-fv2-clear]'), function (b) {
      b.addEventListener('click', clearNeed);
    });

    /* ── Napi üzenet ── */
    var stars = root.querySelectorAll('[data-fv2-star]');
    var msgOut = root.querySelector('[data-fv2-msgout]');
    var msgHint = root.querySelector('[data-fv2-msghint]');
    var msgs = root.querySelectorAll('[data-fv2-msg]');
    var msgLabel = msgOut ? msgOut.querySelector('.fv2-msg__k') : null;
    var labelBase = msgLabel ? msgLabel.textContent.trim() : '';

    Array.prototype.forEach.call(stars, function (star) {
      star.addEventListener('click', function () {
        var idx = star.getAttribute('data-fv2-star');
        for (var i = 0; i < msgs.length; i++) {
          msgs[i].hidden = msgs[i].getAttribute('data-fv2-msg') !== String(idx);
        }
        if (msgOut) msgOut.hidden = false;
        if (msgHint) msgHint.hidden = true;
        if (msgLabel && labelBase) {
          var d = '';
          try { d = new Date().toLocaleDateString('hu-HU', { year: 'numeric', month: 'long', day: 'numeric' }); } catch (e) { d = ''; }
          msgLabel.textContent = d ? labelBase + ' · ' + d : labelBase;
        }
      });
    });
  }

  /* Velemeny-pakli: egy aktiv lap kozepen, a tobbi melysegben mogotte.
     Sajat megoldas, nulla kulso konyvtar. A huzas Pointer Events-szel megy, ezert
     az erintes es az eger UGYANAZT az agat hasznalja — nem ket kulon kezelo.
     A `touch-action:pan-y` (CSS) miatt a fuggoleges oldalgorgetes valtozatlan marad. */
  function initDeck(root) {
    var deck = root.querySelector('[data-fv2-deck]');
    if (!deck) return;
    var lapok = [].slice.call(deck.querySelectorAll('.fv2-rev'));
    if (lapok.length < 2) return;
    var pontok = [].slice.call(root.querySelectorAll('[data-fv2-deck-dot]'));
    var akt = 0, huzX = 0, huzas = false, indX = 0, indY = 0, tengely = '';

    /* A pakli CSAK mobilon el — desktopon a szekcio a regi vizszintes gorgetos szerkezetet hasznalja.
       A hatar ugyanaz a 640px, ami a szekcio TOBBI mobil szabalyanak is a hatara (nem uj torespont).
       A CSS-ben ugyanez a media query all; itt a JS-oldali par: desktopon nem fut a huzas-kezelo,
       es nem marad ott a JS-bol szamolt magassag-kenyszer sem. */
    var mq = window.matchMedia('(max-width:640px)');
    var aktiv = false;

    function bekapcsol() {
      if (aktiv) return;
      aktiv = true;
      rajzol();
    }

    function kikapcsol() {
      if (!aktiv) return;
      aktiv = false;
      huzas = false;
      akt = 0;
      for (var i = 0; i < lapok.length; i++) {
        lapok[i].removeAttribute('data-pos');
        lapok[i].removeAttribute('aria-hidden');
        lapok[i].classList.remove('is-drag', 'is-out');
        lapok[i].style.transform = '';
      }
      for (var k = 0; k < pontok.length; k++) pontok[k].removeAttribute('aria-current');
      deck.style.minHeight = '';
      deck.style.removeProperty('--fv2-deck-h');
    }

    function rajzol() {
      for (var i = 0; i < lapok.length; i++) {
        var t = (i - akt + lapok.length) % lapok.length;
        lapok[i].setAttribute('data-pos', t > 3 ? 3 : t);
        lapok[i].setAttribute('aria-hidden', t === 0 ? 'false' : 'true');
        lapok[i].classList.remove('is-drag', 'is-out');
        lapok[i].style.transform = '';
      }
      for (var k = 0; k < pontok.length; k++) {
        pontok[k].setAttribute('aria-current', k === akt ? 'true' : 'false');
      }
      magassag();
    }

    /* A lapok abszolut pozicioban ulnek, ezert a konteneRnek sajat magassag kell.
       A legmagasabb lap adja — kulonben a kovetkezo szekcio felcsuszna.
       UGYANEZ a magassag megy vissza MINDEN lapra (--fv2-deck-h): egyenlo magassagu lapoknal
       a hatso lapokbol pontosan a szandekolt 14/26/34px-nyi PEREM kukucskal ki, tartalom nem.
       A meres elott a valtozot 'auto'-ra kell allitani, kulonben a sajat korabbi erteket mernenk
       vissza (a lap magassaga mar nem a tartalomtol fuggne). */
    function magassag() {
      deck.style.setProperty('--fv2-deck-h', 'auto');
      var m = 0;
      for (var i = 0; i < lapok.length; i++) {
        var h = lapok[i].offsetHeight; /* olvasas = kenyszeritett reflow, tehat friss ertek */
        if (h > m) m = h;
      }
      if (m) {
        deck.style.setProperty('--fv2-deck-h', m + 'px');
        deck.style.minHeight = (m + 46) + 'px';
      }
    }

    function lep(irany) {
      akt = (akt + irany + lapok.length) % lapok.length;
      rajzol();
    }

    deck.addEventListener('pointerdown', function (e) {
      if (!aktiv) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      huzas = true; tengely = ''; indX = e.clientX; indY = e.clientY; huzX = 0;
      lapok[akt].classList.add('is-drag');
    });

    deck.addEventListener('pointermove', function (e) {
      if (!aktiv || !huzas) return;
      var dx = e.clientX - indX, dy = e.clientY - indY;
      /* Az elso ~8px donti el, vizszintes huzas-e vagy fuggoleges gorgetes.
         Enelkul a lap minden fuggoleges gorgetesnel megrandulna. */
      if (!tengely) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        tengely = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (tengely === 'y') { huzas = false; lapok[akt].classList.remove('is-drag'); return; }
      }
      huzX = dx;
      var d = Math.max(-1, Math.min(1, dx / 240));
      /* doles + hatratolas: ettol 3D a mozgas, nem lapos oldalra-csusztatas */
      lapok[akt].style.transform =
        'translate3d(' + dx + 'px,' + (Math.abs(dx) * 0.05) + 'px,' + (-Math.abs(d) * 70) + 'px)' +
        ' rotateY(' + (d * -16) + 'deg) rotate(' + (d * 3.4) + 'deg)';
    });

    function elenged() {
      if (!aktiv || !huzas) return;
      huzas = false;
      var lap = lapok[akt];
      lap.classList.remove('is-drag');
      if (Math.abs(huzX) > 62) {
        var jobbra = huzX > 0;
        lap.classList.add('is-out');
        lap.style.transform = 'translate3d(' + (jobbra ? 460 : -460) + 'px,40px,-120px) rotateY(' +
          (jobbra ? -26 : 26) + 'deg) rotate(' + (jobbra ? 8 : -8) + 'deg)';
        setTimeout(function () { lep(jobbra ? -1 : 1); }, 240);
      } else {
        lap.style.transform = '';
      }
      huzX = 0;
    }
    deck.addEventListener('pointerup', elenged);
    deck.addEventListener('pointercancel', elenged);
    deck.addEventListener('pointerleave', elenged);

    deck.addEventListener('keydown', function (e) {
      if (!aktiv) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); lep(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); lep(-1); }
    });

    for (var k = 0; k < pontok.length; k++) {
      (function (idx) {
        pontok[idx].addEventListener('click', function () { if (!aktiv) return; akt = idx; rajzol(); });
      })(k);
    }

    window.addEventListener('resize', function () { if (aktiv) magassag(); });

    /* Ablak-atmeretezesnel (vagy keszulek-forgatasnal) a hatar mindket iranyban atlephető:
       befele a pakli felepul, kifele MINDEN nyoma eltunik (attributumok, inline transform, magassag). */
    function hatar(e) { if (e.matches) { bekapcsol(); } else { kikapcsol(); } }
    if (mq.addEventListener) { mq.addEventListener('change', hatar); }
    else if (mq.addListener) { mq.addListener(hatar); }

    if (mq.matches) bekapcsol();
    /* a betuk beallasa utan a lapok magassaga valtozhat */
    setTimeout(function () { if (aktiv) magassag(); }, 400);
    setTimeout(function () { if (aktiv) magassag(); }, 1400);
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-fv2]');
    Array.prototype.forEach.call(roots, function (r) { initRoot(r); initDeck(r); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target || document;
    var root = el.querySelector ? el.querySelector('[data-fv2]') : null;
    if (root) { root.__fv2Init = false; initRoot(root); }
  });
})();
